import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { CheckCircle, ListChecks, TrendingUp, XCircle } from "lucide-react";
import React from "react";
import { useGetRunHistorySummary } from "../../../hooks";

const RunHistoryDashboard = () => {
  const { data: runHistorySummaryData } = useGetRunHistorySummary();
  const statsData = [
    {
      title: "Total executions",
      count: runHistorySummaryData?.result?.totalExecutions || 0,
      icon: <ListChecks className="h-7 w-7 text-gray-600" />,
    },
    {
      title: "Successful",
      count: runHistorySummaryData?.result?.successful || 0,
      icon: <CheckCircle className="h-7 w-7 text-green-600" />,
    },
    {
      title: "Failed",
      count: runHistorySummaryData?.result?.failed || 0,
      icon: <XCircle className="h-7 w-7 text-red-600" />,
    },
    {
      title: "Success rate",
      count: runHistorySummaryData?.result?.successRate || 0,
      icon: <TrendingUp className="h-7 w-7 text-blue-600" />,
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default RunHistoryDashboard;
